import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import EmployeeManagementLayer from "../components/EmployeeManagementLayer";

const EmployeeManagementPage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Employee Management" />
        <EmployeeManagementLayer />
      </MasterLayout>
    </>
  );
};

export default EmployeeManagementPage;
